export default "__VITE_ASSET__e231b4eb__"